import React,{lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from 'container/loginPage';
import Box from '@mui/material/Box';
import { MainLayout, RegisterMainLayout } from 'container/layout';
import Footer from '../dashboard/Footer';
import { Page } from '_components';
const LoginLayout = () => {
  const Register = lazy(() => import('container/registration').then(module => ({ default: module.Register })));

  return (
    <div className="login-container">
      <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<Page defaultTitle="Login"><Login /></Page>} />
        </Route>
        <Route element={<RegisterMainLayout />}>
          <Route path='register' element={<Page defaultTitle="Registration"><Register /></Page>} />
        </Route>
      </Routes>
      <Box className="clear-both">
      </Box>
      <Footer/>
      </Suspense>
    </div>
  );
};

export default LoginLayout;